/* global FavoritesEnabled */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import Badge from 'components/Badge';
import Icon from 'components/Icon';
import Favorite, { FAVORITE_TYPE_ICON, FAVORITE_TEXT_POSITION_RIGHT } from 'components/Favorite';
import StringList from 'components/StringList';
import ReadMore from 'components/ReadMore';
import { noop } from 'helpers/GlobalHelper';
import { SHOW_STATE_LIVE, SHOW_STATE_UPNEXT } from 'helpers/BadgeHelper';
import { PageNames, SegmentSources, tealiumEventPageTypes } from '@foxcorp/delta-web-analytics';
import { isMovie, castProcessor } from 'helpers/ContentHelper';
import { helperGetSeriesDetailUrl } from 'helpers/RouteHelper';
import favoriteTheme from './Favorite.css';
import readMoreTheme from './ReadMore.css';

class WatchDetailComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleDetailStatus: false,
    };
  }

  onToggleClick = () => {
    const { toggleDetailStatus } = this.state;
    this.setState({ toggleDetailStatus: !toggleDetailStatus });
  };

  handleHover = hover => {
    const { setPlayerDataHover } = this.props;
    if (setPlayerDataHover) setPlayerDataHover(hover);
  };

  renderCreditsTags({ minimal }) {
    const { videoPage_castLabel: castLabel } = window.Language;
    const { theme, actors } = this.props;
    if (!actors || !actors.length) return null;
    if (minimal) {
      return (
        <StringList
          label={castLabel}
          items={actors}
          processor={castProcessor}
          className={theme.creditsString}
        />
      );
    }
    return (
      <div className={theme.creditsWrapper}>
        <StringList
          label={castLabel}
          items={actors}
          processor={castProcessor}
          className={theme.subtextCredits}
        />
      </div>
    );
  }

  renderDescriptionItem() {
    const { description, theme } = this.props;
    if (!description) return null;
    return (
      <ReadMore
        className={theme.descriptionWrapper}
        moreText="More"
        lessText="Less"
        lines={1}
        theme={readMoreTheme}
      >
        {description}
      </ReadMore>
    );
  }

  renderFavorite() {
    const {
      disableFavorite,
      favoritableItems,
      favoritesManager,
      network,
      recommendationId,
      seriesName,
      showCode: showID,
    } = this.props;
    if (!FavoritesEnabled || disableFavorite) return null;

    const location = _.get(tealiumEventPageTypes, PageNames.FAVORITES_DETAIL);
    const source = SegmentSources.VOD;
    const type = FAVORITE_TYPE_ICON;
    const textPosition = FAVORITE_TEXT_POSITION_RIGHT;
    let defaultText;

    const favoriteData = {
      favoritableItems,
      location,
      networkId: network,
      recommendationId,
      seriesName,
      showID,
      source,
    };

    return (
      <Favorite
        manager={favoritesManager}
        data={favoriteData}
        type={type}
        textPosition={textPosition}
        theme={favoriteTheme}
        defaultText={defaultText}
      />
    );
  }

  renderInfoDetail() {
    const { theme, networkIcon, description, tuneIn } = this.props;
    const { videoPage_tuneinLabel: tuneInLabel } = window.Language;
    const { toggleDetailStatus } = this.state;
    let infoContainerClasses = classNames(theme.infoContainer, theme.hidden);
    if (toggleDetailStatus) {
      infoContainerClasses = theme.infoContainer;
    }
    const tuneInText = () => {
      if (tuneIn) {
        const formattedText = tuneIn[0].toUpperCase() + tuneIn.substr(1).toLowerCase();
        return `${formattedText} on`;
      }
      return tuneIn;
    };
    const creditsTags = this.renderCreditsTags({});
    const tuneInTags = tuneIn ? (
      <div className={theme.tuneInWrapper}>
        <span className={theme.subtitle}>{tuneInLabel}</span>
        <span className={theme.subtextTuneIn}>{tuneInText()}</span>
        <div className={theme.networkLogoDetail}>
          <img alt="Network Logo" src={networkIcon} />
        </div>
      </div>
    ) : null;
    const descriptionTags = description ? (
      <div className={theme.descriptionWrapper}>
        <span className={theme.subtext}>{description}</span>
      </div>
    ) : null;
    if (!tuneInTags && !descriptionTags && !creditsTags) return null;
    return (
      <div className={infoContainerClasses}>
        <div className={theme.infoCenter}>
          {descriptionTags}
          {creditsTags}
          {tuneInTags}
        </div>
      </div>
    );
  }

  renderWatchDetail() {
    const {
      adPlaying,
      badge,
      hasEndcard,
      isFullscreen,
      isLive,
      isModal,
      metadata,
      networkIcon,
      onTitleClick,
      playerLoading,
      renderInfo,
      seriesScreenUrl,
      showCode,
      showControls,
      showNetworkIcon,
      showSubtitle,
      theme,
      title,
      tuneIn,
      type,
    } = this.props;

    const { toggleDetailStatus } = this.state;
    let detailIconType = 'keyboard-arrow-down';
    let toggleClasses = theme.toggle;
    if (hasEndcard) return null;
    const isMovieType = isMovie(type);
    const movieSubtitle = this.renderCreditsTags({ minimal: true });
    const subtitleText = isMovieType ? movieSubtitle : showSubtitle;
    const hideSubtitle = toggleDetailStatus && isMovieType;
    const subtitleTag = subtitleText && !hideSubtitle && (
      <h2 className={theme.showSubtitle}>{subtitleText}</h2>
    );
    if (toggleDetailStatus) {
      detailIconType = 'keyboard-arrow-up';
      toggleClasses = classNames(toggleClasses, theme.toggleActive);
    }
    const infoDetailComponent =
      ((renderInfo && toggleDetailStatus) || isModal) && this.renderInfoDetail();
    const toggleTags = renderInfo && (
      <Link key="watchDetailToggleLink" onClick={this.onToggleClick} className={toggleClasses}>
        <Icon size="medium" color="grey" icon={detailIconType} theme={theme} />
      </Link>
    );
    const descriptionItem = !renderInfo && !isModal && this.renderDescriptionItem();
    const networkLogoContainerClasses = [theme.logoContainer];
    if (!showNetworkIcon) networkLogoContainerClasses.push(theme.hideNetworkLogo);
    const networkLogoClasses = classNames(
      theme.networkLogo,
      isFullscreen && theme.networkLogoFullscreen,
    );
    const infoDetailTuneInRendered = !(infoDetailComponent && tuneIn);
    const logoComponent = infoDetailTuneInRendered && networkIcon && (
      <div className={classNames(networkLogoContainerClasses)}>
        <div className={networkLogoClasses}>
          <img src={networkIcon} alt="" />
        </div>
      </div>
    );
    let badgeItem = null;
    if (badge) {
      const badgeLive = badge.toUpperCase() === SHOW_STATE_LIVE;
      const badgeInvalidUpNext = isLive && badge.toUpperCase() === SHOW_STATE_UPNEXT;
      if (!badgeLive && !badgeInvalidUpNext) {
        badgeItem = <Badge theme={theme} badge={badge} />;
      }
    }
    const liveIndicator = isLive && <Badge theme={theme} badge={SHOW_STATE_LIVE} liveIndicator />;
    const badgeContainer = (badgeItem || liveIndicator) && (
      <div className={theme.badgeContainer}>
        {badgeItem}
        {liveIndicator}
      </div>
    );
    const containerClasses = [theme.container];
    const url = helperGetSeriesDetailUrl(showCode);
    let titleTag = (
      <Link onClick={onTitleClick} to={url} className={theme.titleLink}>
        {title}
      </Link>
    );
    let titleClasses = theme.title;
    if (!seriesScreenUrl) {
      titleTag = title;
      titleClasses = classNames(theme.title, theme.titleDisabled);
    }
    if (!showControls) containerClasses.push(theme.controlsHidden);
    if (playerLoading) containerClasses.push(theme.playerLoading);
    if (adPlaying) containerClasses.push(theme.adPlaying);

    return (
      <div
        className={classNames(containerClasses)}
        onMouseEnter={() => this.handleHover(true)}
        onMouseLeave={() => this.handleHover(false)}
      >
        <div className={theme.detailContainer}>
          {badgeContainer}
          <div className={theme.titleHeader}>
            <div className={titleClasses}>
              <h1>
                {titleTag} {this.renderFavorite()}
              </h1>
              {toggleTags}
            </div>
            {subtitleTag}
            {descriptionItem}
            <p className={theme.metadata}>{metadata}</p>
          </div>
        </div>
        {infoDetailComponent}
        {logoComponent}
      </div>
    );
  }

  render() {
    return this.renderWatchDetail();
  }
}

WatchDetailComponent.defaultProps = {
  actors: null,
  adPlaying: false,
  badge: null,
  description: null,
  disableFavorite: false,
  favoritableItems: null,
  favoritesManager: null,
  hasEndcard: false,
  isFullscreen: false,
  isLive: false,
  isModal: false,
  metadata: null,
  network: null,
  networkIcon: null,
  onTitleClick: noop,
  playerLoading: false,
  recommendationId: null,
  renderInfo: false,
  seriesScreenUrl: null,
  setPlayerDataHover: noop,
  showNetworkIcon: false,
  showSubtitle: null,
  theme: {},
  tuneIn: null,
};

WatchDetailComponent.propTypes = {
  actors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  adPlaying: PropTypes.bool,
  badge: PropTypes.string,
  description: PropTypes.string,
  disableFavorite: PropTypes.bool,
  favoritableItems: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  hasEndcard: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isLive: PropTypes.bool,
  isModal: PropTypes.bool,
  metadata: PropTypes.string,
  network: PropTypes.string,
  networkIcon: PropTypes.string,
  onTitleClick: PropTypes.func,
  playerLoading: PropTypes.bool,
  recommendationId: PropTypes.string,
  renderInfo: PropTypes.bool,
  seriesName: PropTypes.string.isRequired,
  seriesScreenUrl: PropTypes.string,
  setPlayerDataHover: PropTypes.func,
  showCode: PropTypes.string.isRequired,
  showControls: PropTypes.bool.isRequired,
  showNetworkIcon: PropTypes.bool,
  showSubtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    avatar: PropTypes.string,
    avatarContainer: PropTypes.string,
    container: PropTypes.string,
    hideMore: PropTypes.string,
    info: PropTypes.string,
    infoContainer: PropTypes.string,
    more: PropTypes.string,
    moreContainer: PropTypes.string,
    showTitle: PropTypes.string,
    subtext: PropTypes.string,
    subtitle: PropTypes.string,
    titleHeader: PropTypes.string,
    toggle: PropTypes.string,
    tuneIn: PropTypes.string,
    videoInfoContainer: PropTypes.string,
    videoTitle: PropTypes.string,
  }),
  tuneIn: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default connect()(WatchDetailComponent);
